// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ea308cf1","477":"60cd02a0","513":"c5679ba1","787":"3986d368"}[chunkId] + ".chunk.js";
};